export var getIds = id => id ? {
  root: id,
  outerWrapper: "".concat(id, "__outer-wrapper"),
  innerWrapper: "".concat(id, "__inner-wrapper"),
  navBarWrapper: "".concat(id, "__nav-bar-wrapper"),
  navBar: "".concat(id, "__nav-bar"),
  scrollableArea: "".concat(id, "__scrollable-area"),
  containerWrapper: "".concat(id, "__container-wrapper"),
  container: "".concat(id, "__container"),
  bottom: "".concat(id, "__bottom"),
  backButton: "".concat(id, "__back-button"),
  closeButton: "".concat(id, "__close-button"),
  backgroundClickHandler: "".concat(id, "__background-click-handler"),
  footerButtonWrapper: "".concat(id, "__footer-button-wrapper")
} : undefined;
//# sourceMappingURL=getIds.js.map